import * as React from "react";
import {ChangeEvent} from "react";

import {Button, Card, Checkbox, Col, Form, Icon, Input, Popconfirm, Row, Select, Tooltip} from "antd";
import styles from "./Variables.module.less";
import {FormComponentProps} from "antd/lib/form";
import {ColorInput} from "../Form";
import {get, setWith} from "lodash";
import VariablesFormAdd from "./VariablesFormAdd";

const {Option} = Select;
const {TextArea} = Input;


export const DesignVariablesKeyInCustomCode = "Vars";
export const FeedPreVariablesKeyInCustomCode = "FeedPreVars";
export const FeedPostVariablesKeyInCustomCode = "FeedPostVars";

export type IVariablesFormFields = {
    [key: string]: IFieldValue | IVariablesFormFields | Array<IVariablesFormFields> | undefined;
}

interface IOption {
    value: string;
    label: string
}

export interface IFieldValue {
    type: string;
    value: string | boolean;
    name?: string;
    options?: Array<IOption>;
}

interface IFormComponents {
    [key: string]: any
}

export const formComponents: IFormComponents = {
    "Input": Input,
    "ColorInput": ColorInput,
    "Select": Select,
    "Checkbox": Checkbox,
    "TextArea": TextArea, //TODO fix the \n\n issue
};

export const addingFormComponents = {
    ...formComponents,
    "Group": {},
    "TextStyle": {}
}

interface IVariablesFormProps extends FormComponentProps {
    fields: {
        Master: IVariablesFormFields;
        Child: IVariablesFormFields;
    }
    isMaster?: boolean;
}

export interface IVariablesFormDispatchProps {
    onFormChange?: (changedFields: any) => void;
    onVariablesChange?: (changedVariables: IVariablesFormFields) => void;
}

type IVariablesProps = IVariablesFormProps & IVariablesFormDispatchProps

interface IVariableField {
    name: string,
    type: string,
    options?: Array<IOption>;
    optionsString?: string;
}

interface IState {
    adding: boolean;
    newVariablesGroupName: string;
    addingFormKey: string;
    addingKey: string;
}


class VariablesForm extends React.Component<IVariablesProps, IState> {
    constructor(props: IVariablesFormProps) {
        super(props);
        this.state = {
            newVariablesGroupName: "",
            adding: false,
            addingFormKey: "",
            addingKey: ""
        };
    }

    onNewVariablesGroupNameChange = (event: ChangeEvent<HTMLInputElement>) => {
        this.setState({
            newVariablesGroupName: event.target.value,

        })
    };

    addGroup = () => {
        if (this.props.onFormChange) {
            this.props.onFormChange({
                Master: {
                    [this.state.newVariablesGroupName]: {}
                }
            })
        }
        this.setState({
            newVariablesGroupName: "",
        })
    };

    createFullFormKey = (formKey: string): string => {
        let fullFormKey = "";
        if (this.props.isMaster) {
            fullFormKey = `Master.${formKey}`
        } else {
            fullFormKey = `Child.${formKey}`
        }
        return fullFormKey
    }

    removeVariable = (formKey: string, variableKey: string) => {
        let object = {};
        setWith(object, this.createFullFormKey(formKey), null, Object);
        if (this.props.onFormChange) {
            this.props.onFormChange(object)
        }
    };

    addingVariable = (formKey: string, groupKey: string) => {
        this.setState({
            addingFormKey: formKey,
            addingKey: groupKey,
            adding: true
        })
    };

    overriddenVariable = (formKey: string) => {
        let object = {};
        setWith(object, `Child.${formKey}`, get(this.props.fields.Master, formKey), Object);
        if (this.props.onFormChange) {
            this.props.onFormChange(object)
        }
    };

    onFinishAdding = () => {
        this.setState({
            adding: false
        })
    };

    onAddingNewVariablesField = (name: string, field: IVariablesFormFields): void => {
        if (this.props.onFormChange) {
            let object = {};
            setWith(object, `Master.${this.state.addingFormKey}`, field, Object);
            if (this.props.onFormChange) {
                this.props.onFormChange(object)
            }
        }
    };

    renderItems = () => {
        const {getFieldDecorator} = this.props.form;

        const transformItem = (obj: IFieldValue | IVariablesFormFields | Array<IVariablesFormFields> | undefined, key: string, formKey: string, macro: string): any => {
            let element;
            if (obj && typeof obj === "object") {
                if (!("value" in (obj))) {
                    if (obj instanceof Array) {
                        element = <div key={formKey}>
                            {(obj as Array<IVariablesFormFields>).map((item: IVariablesFormFields, index: number) => {
                                return transformItem(item, key, `${formKey}[${index}]`, `${macro}[${index}]`)
                            })}
                        </div>
                    } else {
                        element = <Card
                            style={{marginBottom: "10px"}}
                            title={formKey}
                            key={formKey}
                            extra={
                                <div>
                                    {this.props.isMaster &&
                                    <React.Fragment>
                                        <Button
                                            type="dashed"
                                            onClick={() => this.addingVariable(formKey, key)}
                                            style={{marginRight: 10}}
                                        >
                                            < Icon type="plus"/> Add Variables
                                        </Button>
                                        <Popconfirm
                                            title={`Are you sure to delete group "${formKey}"?`}
                                            onConfirm={() => this.removeVariable(formKey, key)}
                                            okText="Yes"
                                            cancelText="No"
                                        >
                                            <Icon
                                                className="dynamic-delete-button"
                                                type="minus-circle-o"
                                            />
                                        </Popconfirm>
                                    </React.Fragment>
                                    }
                                </div>
                            }
                        >
                            {
                                Object.keys(obj).map((subKey: string) => {
                                    return transformItem(obj[subKey], subKey, `${formKey}.${subKey}`, `${macro}["${subKey}"]`)
                                })
                            }


                        </Card>
                    }
                } else {
                    let overridden = this.props.isMaster;
                    let field = (obj as IFieldValue);
                    let formKeyPrefix = "Master";
                    let child = get(this.props.fields.Child, formKey);
                    if (!this.props.isMaster && !!child) {
                        formKeyPrefix = "Child";
                        overridden = true;
                        field = child as IFieldValue
                    }

                    let options;
                    const FormComponent = formComponents[field.type];
                    if (field.type === "Select" && field.options) {
                        options = field.options.map((option: IOption) => {
                            return (<Option key={option.value}>{option.label}</Option>)
                        })
                    }

                    let formComponent;
                    if (field.type === "Checkbox" && (field.value as boolean)) {
                        formComponent = <Checkbox disabled={!overridden} defaultChecked={field.value as boolean}/>
                    } else {
                        formComponent = <FormComponent disabled={!overridden} allowClear={overridden}>{options}</FormComponent>
                    }

                    element = (
                        <Form.Item key={formKey} label={key}>
                            <Tooltip title={`{{${macro}}}`}>
                                <Row gutter={24}>
                                    <Col span={20}>
                                        {getFieldDecorator(`${formKeyPrefix}.${formKey}`, {})(formComponent)}
                                    </Col>
                                    <Col span={4}>
                                        {overridden ?
                                            <Popconfirm
                                                title={`Are you sure to delete variable "${key}"?`}
                                                onConfirm={() => this.removeVariable(formKey, key)}
                                                okText="Yes"
                                                cancelText="No"
                                            >
                                                <Icon
                                                    type="minus-circle-o"
                                                />
                                            </Popconfirm>
                                            :
                                            <Icon
                                                type="plus-circle-o"
                                                onClick={() => this.overriddenVariable(formKey)}
                                            />
                                        }
                                    </Col>
                                </Row>
                            </Tooltip>
                        </Form.Item>
                    )
                }
            }
            return element
        };
        const items = Object.keys(this.props.fields.Master).map((key: string) => {
            return transformItem(this.props.fields.Master[key], key, key, `${DesignVariablesKeyInCustomCode}["${key}"]`)
        });

        return items
    };

    rendModal = (formKey: string, key: string) => {
        return (
            <VariablesFormAdd
                visible={this.state.adding}
                onCancel={this.onFinishAdding}
                formKey={formKey}
                groupKey={key}
                onAddingNewVariablesField={this.onAddingNewVariablesField}
            />
        )
    };

    render() {
        // console.log("VariablesForm render........")
        const formItemLayout = {
            labelCol: {span: 6},
            wrapperCol: {span: 16},
        };
        const Modal = this.rendModal(this.state.addingFormKey, this.state.addingKey)
        return (
            <div className={styles.outContainer}>

                <Form {...formItemLayout} layout="horizontal" labelAlign={'left'}>

                    {this.renderItems()}
                    {Modal}

                    {this.props.isMaster &&
                    <React.Fragment>
                        <Form.Item>
                            <Input
                                value={this.state.newVariablesGroupName}
                                onChange={this.onNewVariablesGroupNameChange}
                                placeholder="Group name"
                                style={{marginRight: 8}}
                            />
                        </Form.Item>

                        <Form.Item>
                            <Button type="dashed" onClick={this.addGroup}>
                                <Icon type="plus"/> Add Variables Group
                            </Button>
                        </Form.Item>
                    </React.Fragment>
                    }

                </Form>
            </div>
        )
    }
}

const transform = (obj: IVariablesFormFields): any => {
    return Object.keys(obj).reduce((result: {}, key: string) => {
        let formField;
        if (obj[key]) {
            if (typeof obj[key] === "object" && !("value" in (obj[key] as IVariablesFormFields))) {
                if (obj[key] instanceof Array) {
                    formField = (obj[key] as Array<IVariablesFormFields>).map((item: IVariablesFormFields) => transform(item))
                } else {
                    formField = transform(obj[key] as IVariablesFormFields)
                }
            } else {
                formField = Form.createFormField({
                    ...obj[key],
                    value: (obj[key] as IFieldValue).value
                })
            }

            return {
                ...result,
                [key]: formField
            }

        }
        return result;

    }, {})
};

const VariablesFormComponent = Form.create<IVariablesProps>({
    name: 'variables',
    onFieldsChange(props: IVariablesProps, changedFields: { Master: IVariablesFormFields, Child: IVariablesFormFields }) {
        if (props.onFormChange) {
            props.onFormChange(changedFields);
        }
    },
    mapPropsToFields(props: IVariablesProps) {
        const form = transform(props.fields);
        return form
    },
    onValuesChange(props: IVariablesProps, values) {
        if (props.onVariablesChange) {
            props.onVariablesChange(values);
        }
    },
})(VariablesForm);


export default VariablesFormComponent;

